<div [dir]="direction" class="chat-input-container">
  <!-- User Avatar -->
  <img [src]="(currentUser$ | async).avatar_url" class="user-avatar" />

  <div class="input-container">
    <!-- Markup Toolbar -->
    <div class="markup-toolbar">
      <button type="button" (click)="insertMarkdownSyntax('bold')">Bold</button>
      <button type="button" (click)="insertMarkdownSyntax('italic')">
        Italic
      </button>
      <button type="button" (click)="insertMarkdownSyntax('link')">Link</button>
    </div>

    <!-- Textarea for Chat Message -->
    <textarea
      #messageTextarea
      [value]="value"
      (input)="onInput($event)"
      (blur)="onTouched()"
      placeholder="Type your message here..."
      class="message-textarea"
    >
    </textarea>
  </div>
</div>
